export class NameVal {
  public Name: string;
  public Value: any;

  public constructor(itemName?: string, itemValue?: any) {
    if (itemName == null || itemName == undefined) {
      this.Name = '';
    } else {
      this.Name = itemName;
    }
    if (itemValue == null || itemValue == undefined) {
      this.Value = null;
    } else {
      this.Value = itemValue;
    }
  }
}
